import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";

import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import $ from "jquery";

import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";

import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import API from "../../../Common/api";
import Util from '../../../Common/util';

import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';



var url = window.location.hostname;
var port = window.location.port;
const Heading = [
    [
      "Id",
      "Retailer Code",
      "Cross-Dock",
      "Latitude",
      "Longitude",
      "Phone No.",
      "Address",
      "SMS Required",
      "Party Name",
      "Delivery center Id"
    ],
  ];




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.fetchBinData = this.fetchBinData.bind(this);

    this.state = {
      loading_overlay: false,

      posts: [],

      loading: false,

      isLoading: true,
      showFetchBinData: true,

      filtered_orderData: [],

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    this.fetchBinData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie("token");
    var location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }



  fetchBinData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true,
    });

    const payload = {
      master_type: "retailer_master",
      location: this.state.selectedLocation,
    };
    API.post("/customer/view/v1/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
        this.setState({ posts: data.data, filtered_orderData: data.data });
      })

      .then(async () => {
        this.setState({ tableRows: this.assemblePosts(), isLoading: false });
      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      var value = this.state.posts.filter((val) => {
        return Object.keys(val).some((key) => {
          var data = "";
          if (val[key] == null) {
            data = "";
          } else {
            data = val[key];
          }

          return data.toString().toLowerCase().includes(evt.toLowerCase());
        });
      });
      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = () => {
    let posts = this.state.posts.map((post) => {
      return {
        retailer_code: post.retailer_code,
        cross_dock: post.cross_dock,

        latitude: post.latitude,
        lon: post.lon,

        phone_no: post.phone_no,
        address: post.address,
        sms_required: post.sms_required,
        party_name: post.party_name,
      };
    });

    this.setState({
      loading_overlay: false,
    });

    return posts;
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem);
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;

    const data = {
      columns: [
        {
          label: "Retailer Code",

          field: "retailer_code",
          sort: "asc",
        },

         {
          label: "Cross-Dock",

          field: "cross_dock",
          sort: "asc",
        },

        {
          label: "Latitude",

          field: "latitude",
          sort: "asc",
        },

        {
          label: "Longitude",

          field: "lon",
          sort: "asc",
        },

        {
          label: "Phone No.",

          field: "phone_no",
          sort: "asc",
        },

        {
          label: "Address",

          field: "address",
          sort: "asc",
        },

        {
          label: "SMS Required",

          field: "sms_required",
          sort: "asc",
        },
        {
          label: "Party Name",

          field: "party_name",
          sort: "asc",
        },
      ],

      rows: this.state.tableRows,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          {this.state.showFetchBinData && (
            <CardBody style={{ marginTop: 20 }}>
              <div
                className="table_header"
                style={{ borderBottomWidth: "0px" }}
              >
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  Retailer Master
                </h4>

                <span
                  className="pull-right"
                  onClick={() =>
                    exportToCSV(this.state.filtered_orderData, "RetailerMaster", Heading)
                  }
                  style={{
                    fontSize: "17px",
                    paddingRight: "0px",
                    cursor: "pointer",
                    color: "#919193",
                    paddingTop: "9px",
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>
              </div>
              <hr style={{ marginTop: "30px", marginBottom: "0px" }} />
              <MDBDataTable
                striped
                bordered
                onSearch={this.filterData}
                hover
                sortable={false}
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'retailer_master_view', 'datatable_pagination_change' )}
                data={data}
              />
            </CardBody>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
